// extracted by mini-css-extract-plugin
export default {"cartButton--giftBox":"DaGKChTpSqG6dPSeV1nvQA==","cartButton__giftBoxLabel":"tfHHpkvuHhjyvH6vJNxPxQ=="};